import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true,
});

const getCsrfToken = () => document.cookie
  .split('; ')
  .find((cookie) => cookie.startsWith('csrf_token='))
  ?.split('=')
  .slice(1)
  .join('=');

api.interceptors.request.use(
  (config) => {
    const method = (config.method || 'get').toLowerCase();
    const csrfToken = getCsrfToken();
    if (!['get', 'head', 'options'].includes(method) && csrfToken) {
      config.headers['X-CSRF-Token'] = decodeURIComponent(csrfToken);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const path = originalRequest?.url || '';
    const isAuthRequest = ['/login', '/refresh', '/logout'].some((endpoint) => path.endsWith(endpoint));

    if (error.response?.status === 401 && !originalRequest?._retry && !isAuthRequest) {
      originalRequest._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = api.post('/auth/refresh').finally(() => {
            refreshPromise = null;
          });
        }
        await refreshPromise;
        return api(originalRequest);
      } catch (_refreshError) {
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
